import { createFileRoute } from "@tanstack/react-router";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import VendorCreateForm from "./-form";
import { VendorCrumbs } from "./-crumbs";

export const Route = createFileRoute("/_private/_warehouse-360/vendor/create")({
  component: VendorCreatePage,
});

function VendorCreatePage() {
  return (
    <div>
      <title>Create Vendor - Legrande Health Portal</title>
      <VendorCrumbs />
      <Card>
        <CardHeader>
          <CardTitle>Create Vendor</CardTitle>
          <CardDescription>Enter vendor details below.</CardDescription>
        </CardHeader>
        <CardContent>
          <VendorCreateForm />
        </CardContent>
      </Card>
    </div>
  );
}
